import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useGeneralContext } from "../context/AppGeneralContext";
import { useRTContext } from "../context/RTContext";
import { getSchoolClassesRoute } from "../helpers/navigationHelper";

const useSchoolClassPage = (loginRedirectPath: string, schoolClassId?: string) => {
    const history = useHistory();
    const { userId, loginUser, userInfo } = useGeneralContext();
    const { schoolClasses, reloadSchoolClasses } = useRTContext();

    const [isLoaded, setIsLoaded] = useState(false);

    const isTeacher = userInfo.visitorOrUserRole?.toLowerCase() === "teacher";
    const schoolClass = schoolClassId ? schoolClasses.find((c) => c.token === schoolClassId) : undefined;

    useEffect(() => {
        if (userId) {
            if (isTeacher) {
                reloadSchoolClasses().finally(() => setIsLoaded(true));
            } else {
                history.push("/assistent");
            }
        } else {
            loginUser(loginRedirectPath).catch(() => {
                history.push("/unauthorized");
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId, isTeacher]);

    useEffect(() => {
        if (schoolClassId && isLoaded && !schoolClass) {
            history.replace(getSchoolClassesRoute());
        }
    }, [schoolClassId, isLoaded, schoolClass, history]);

    return { isLoaded, schoolClass };
};

export default useSchoolClassPage;
